const ROUTE_PATHS = {
  home: '/',
  station: '/station/:id/:type',
  widget: '/widget/:id/:type?',
  privacyPolicy: '/privacypolicy',
  termsOfService: '/termsofservice',
  about: '/about',
  callback: '/callback',
  logout: '/logout',
  notFound: '*'
};

export { ROUTE_PATHS };
